/*
 * Created on 26.04.2019.
 *
 * Copyright(c) 1995 - 2019
 * T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Abstrakte Klasse für Services, die Konfigurationen für Dateiuploads bereitstellen.
 */
@Injectable()
export abstract class IUploadFileSizeConfigService {

    /** Standardgröße. */
    static readonly DEFAULT_MAX_FILESIZE = 21; // 21 MB

    /**
     * Subject, das Änderungen der Filesize in MB propagiert.
     */
    protected $fileSize: BehaviorSubject<number> = new BehaviorSubject(IUploadFileSizeConfigService.DEFAULT_MAX_FILESIZE);

    /**
     * Gibt die aktuell hinterlegte Filesize in MB zurück.
     */
    get currentFileSize(): number {
        return this.$fileSize.value;
    }

    /**
     * Gibt die aktuell hinterlegte maximale Dateigröße als Observable zurück.
     * Da im Hintergrund ein BehaviorSubject benutzt wird, ist es kein Problem
     * erst später zu subscriben. Man erhält dennoch den neuesten Wert.
     */
    getMaxFileSizeObservable(): Observable<number> {
        return this.$fileSize.asObservable();
    }

    /**
     * Setzt die aktuell hinterlegte maximale Dateigröße auf den Parameter in MB.
     * @param fileSize in MB
     */
    setMaxFileSize(fileSize: number) {
        this.$fileSize.next(fileSize);
    }
}
